import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDroppableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Exposing a DOM ref from your Component
// Docs: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
const List = ({ provided, innerRef, children }) => (
  <StyledDroppableContainer
    {...provided.draggableProps}
    {...provided.dragHandleProps}
    ref={innerRef}
  >
    {children}
  </StyledDroppableContainer>
);

export default List;
